import React, { useState } from "react";
import { Container, Row, Col, Modal, Button } from "react-bootstrap";
import { FaFacebookSquare, FaInstagram, FaTwitterSquare } from "react-icons/fa";
import "../src/Footer.css";
import WhatsAppShareButton from "./WhatsAppShareButton";

const Footer = () => {
  const currentYear = new Date().getFullYear();
  const [showAboutYaasaai, setShowAboutYaasaai] = useState(false);
  const [showContactUs, setShowContactUs] = useState(false);
  const [showReturnPolicy, setShowReturnPolicy] = useState(false); // 🚀 New state for modal
  const [showTermsPolicy, setShowTermsPolicy] = useState(false);

  return (
    <>
      <Container fluid className="footer-container mt-4">
        <Row className="text-center text-md-start flex-wrap px-3">
          <Col xs={4} sm={6} md={4} className="mb-4">
            <h5
              style={{
                padding: "8px 5px",
                fontSize: "15px",
                backgroundColor: "coral",
                color: "white",
                border: "none",
                borderRadius: "6px",
                boxShadow: "0 2px 6px rgba(0,0,0,0.2)",
                transition: "0.3s",
              }}
            >
              Information
            </h5>
            <a
              href="#"
              className="footer-link d-block"
              onClick={() => setShowAboutYaasaai(true)}
            >
              About Us
            </a>
            <a
              href="#"
              className="footer-link d-block"
              onClick={() => setShowContactUs(true)}
            >
              Contact Us
            </a>
          </Col>

          <Col xs={4} sm={6} md={4} className="mb-4">
            <h5
              style={{
                padding: "8px 5px",
                fontSize: "15px",
                backgroundColor: "coral",
                color: "white",
                border: "none",
                borderRadius: "6px",
                boxShadow: "0 2px 6px rgba(0,0,0,0.2)",
                transition: "0.3s",
              }}
            >
              Help
            </h5>
            <a
              href="#"
              className="footer-link d-block"
              onClick={() => setShowTermsPolicy(true)}
            >
              Privacy Policy
            </a>
            <a
              href="#"
              className="footer-link d-block"
              onClick={() => setShowReturnPolicy(true)}
            >
              Return Policy
            </a>
          </Col>

          <Col xs={4} md={4} className="mb-4">
            <h5
              style={{
                padding: "8px 5px",
                fontSize: "15px",
                backgroundColor: "coral",
                color: "white",
                border: "none",
                borderRadius: "6px",
                boxShadow: "0 2px 6px rgba(0,0,0,0.2)",
                transition: "0.3s",
              }}
            >
              Follow Us
            </h5>
            <div className="social-icons d-flex justify-content-center justify-content-md-start gap-3 mt-2">
              <a
                href="https://www.facebook.com/profile.php?id=61576771997137"
                target="_blank"
                rel="noopener noreferrer"
                title="follow on facebook page"
              >
                <FaFacebookSquare size={30} className="social-icon-fb" />
              </a>
              <a
                href=" https://www.instagram.com/yaasaai_vegfruits?igsh=NzY2b2Y1ZmJod3o4&utm_source=ig_contact_invite"
                target="_blank"
                rel="noopener noreferrer"
                title="follow on instagram page"
              >
                <FaInstagram size={30} className="social-icon-insta" />
              </a>

              <WhatsAppShareButton />
            </div>
          </Col>
        </Row>

        <Row
          className="text-center py-1"
          style={{ background: "coral", color: "#fff" }}
        >
          <Col>
            <p>
              Website Designed, Developed, Maintained and Hosted By Tonktech
              Development Group
            </p>
            <p>yaasaai.com All Rights Reserved © {`2021-${currentYear}`}</p>
          </Col>
        </Row>
      </Container>

      {/* About Yaasaai Modal */}
      <Modal
        show={showAboutYaasaai}
        onHide={() => setShowAboutYaasaai(false)}
        centered
        size="lg"
        scrollable
      >
        <Modal.Header closeButton>
          <h4 style={{ color: "#27ae60", fontWeight: "bold" }}>
            🥬 About Yaasaai
          </h4>
        </Modal.Header>
        <Modal.Body
          style={{ fontSize: "15px", lineHeight: "1.7", color: "grey" }}
        >
          <div style={{ padding: "10px 15px" }}>
            <p className="about_us">
              <strong>Yaasaai</strong> is your trusted online store for fresh
              vegetables and fruits, delivered straight to your home across
              Tonk.
            </p>
            <p className="about_us">
              We bring you farm-fresh, seasonal produce directly from the local
              market — Our goal is to make your daily shopping simple,
              affordable, and super fresh.
            </p>
            <p className="about_us">
              Whether you're a busy parent, a health lover, or just want quality
              groceries at your doorstep — <strong>Yaasaai</strong> is here for
              you.
            </p>

            <hr style={{ margin: "20px 0", borderTop: "1px dashed #ccc" }} />

            <h5 style={{ color: "#2c3e50" }}>🌟 Why Choose Yaasaai?</h5>
            <ul>
              <li>
                🥬 <strong>Fresh & Seasonal:</strong> Only the best seasonal
                veggies and fruits — full of taste and nutrition.
              </li>
              <li>
                🚚 <strong>Fast Delivery:</strong> Get your order delivered
                quickly to your home – no long waiting!
              </li>
              <li>
                💰 <strong>Affordable Prices:</strong> Quality groceries at
                prices you'll love — no middlemen, no extra cost.
              </li>
              <li>
                📦 <strong>Safe & Clean Packaging:</strong> Hygienic packing,
                fresh quality — your safety is our priority.
              </li>
              <li>
                📞 <strong>Easy Support:</strong> Order via App, Website,
                WhatsApp or Call — we’re always here to help.
              </li>
            </ul>

            <hr style={{ margin: "20px 0", borderTop: "1px dashed #ccc" }} />

            <h5 style={{ color: "#2c3e50" }}>📍 Now Delivering In:</h5>
            <p className="about_us">
              📌 <strong>Tonk</strong>
            </p>

            <h6
              style={{
                marginTop: "20px",
                color: "#27ae60",
                fontWeight: "bold",
              }}
            >
              ✅ Yaasaai – Freshness at your doorstep!
              <br />
              ✅ Yaasaai – your choice your shop!
              <br />
            </h6>
          </div>
        </Modal.Body>
        {/*
        <Modal.Footer>
          <Button
            variant="secondary"
            onClick={() => setShowAboutYaasaai(false)}
          >
            Close
          </Button>
        </Modal.Footer>
        */}
      </Modal>

      {/* contact us Yaasaai Modal */}
      <Modal
        show={showContactUs}
        onHide={() => setShowContactUs(false)}
        centered
        size="lg"
        scrollable
      >
        <Modal.Header closeButton>
          <h4 style={{ color: "#2980b9", fontWeight: "bold" }}>
            📞 Contact Us – Yaasaai
          </h4>
        </Modal.Header>
        <Modal.Body
          style={{ fontSize: "15px", lineHeight: "1.7", color: "#333" }}
        >
          <div style={{ padding: "10px 15px" }}>
            <p className="about_us">
              We’d love to hear from you! Whether you have a question, feedback,
              or need help with your order — our team is here to assist you.
              🧑‍🌾✨
            </p>

            <hr style={{ margin: "15px 0", borderTop: "1px dashed #ccc" }} />

            <h6 style={{ color: "#2c3e50" }}>📬 Reach Us At:</h6>
            <p className="about_us">
              📱 <strong>Phone / WhatsApp:</strong>
              <br />
              📞 <a href="tel:+917793045535">+91-7793045535</a>
              <br />
              📞 <a href="tel:+917014496283">+91-7014496283</a>
              <br />
              💬 <em>Available from 8 AM – 9 PM daily</em>
            </p>

            <p className="about_us">
              📧 <strong>Email:</strong>
              <br />
              ✉️ yaasaaitonk@gmail.com
              <br />
              <em>For queries, suggestions, or business inquiries</em>
            </p>

            <p className="about_us">
              🌐 <strong>Website:</strong>
              <br />
              🔗{" "}
              <a
                href="https://www.yaasaai.com"
                target="_blank"
                rel="noopener noreferrer"
              >
                www.yaasaai.com
              </a>
            </p>

            <hr style={{ margin: "15px 0", borderTop: "1px dashed #ccc" }} />

            <h6 style={{ color: "#2c3e50" }}>🕐 Customer Support Hours:</h6>
            <p className="about_us">
              🗓️ Monday to Sunday
              <br />⏰ 8:00 AM to 9:00 PM
            </p>

            <hr style={{ margin: "15px 0", borderTop: "1px dashed #ccc" }} />

            <h6 style={{ color: "#2c3e50" }}>📍 Office Location:</h6>
            <p className="about_us">
              🏢 <strong>Yaasaai – Veg & Fruits</strong>
              <br />
              Near Kamdhenu Circle
              <br />
              Tonk, Rajasthan – 304001
            </p>
          </div>
        </Modal.Body>
        {/*
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowContactUs(false)}>
            Close
          </Button>
        </Modal.Footer>
        */}
      </Modal>

      {/* Terms & Services Modal */}
      <Modal
        show={showTermsPolicy}
        onHide={() => setShowTermsPolicy(false)}
        centered
        size="lg"
        scrollable
      >
        <Modal.Header closeButton>
          <h4 style={{ fontWeight: "bold", color: "#007bff", margin: 0 }}>
            📄 Privacy Policy
          </h4>
        </Modal.Header>

        <Modal.Body
          style={{
            fontSize: "0.85rem",
            lineHeight: "1.6",
            overflowY: "auto", // enable vertical scroll
            paddingRight: "1rem",
          }}
        >
          <p className="contents">
            <strong>
              Welcome to <span style={{ color: "#28a745" }}>Yaasaai.com</span>
            </strong>
            . By accessing or using our website, you agree to be bound by the
            following terms and policies.
          </p>

          <p className="contents">
            We understand that privacy online is important to users of our site,
            especially when conducting business. This statement governs our
            privacy policies for both "Visitors" who browse the site and
            "Authorized Customers" who register and use our services.
          </p>

          <p className="contents">
            By using our Service, you agree to the collection and use of your
            information as outlined below. We use your data only to provide and
            improve the service — we do not share it beyond the scope of this
            policy.
          </p>
          <h5
            style={{ fontWeight: "bold", marginTop: "1rem", color: "#17a2b8" }}
          >
            🔒 Privacy Policy: Permissions Usage
          </h5>
          <p className="contents">
            📍 Location Permission 👉 Why We Request Location Access:
            <ul
              style={{
                paddingLeft: "20px",
                fontSize: "15px",
                fontWeight: "bold",
                color: "#555",
              }}
            >
              <li>
                📦 Provide accurate delivery service to your current or chosen
                address.
              </li>
              <li>
                🚚 Show you real-time tracking of your orders and the delivery
                person's location.
              </li>
              <li>
                🏬 Recommend nearby shops or services based on your location.
              </li>
            </ul>
            🔔 Notification Permission 👉 Why We Request Notification Access:
            <ul
              style={{
                paddingLeft: "20px",
                fontSize: "15px",
                fontWeight: "bold",
                color: "#555",
              }}
            >
              <li>
                📬 Send important order updates, such as order confirmation,
                delivery status, and ETA.
              </li>
              <li>💰 Notify you of exclusive deals, offers, or discounts.</li>
              <li>
                🚨 Alert you about important service announcements (e.g.,
                delays, outages).
              </li>
            </ul>
            🔐 Your Privacy Matters :We do not collect or store personal data
            unnecessarily. All permissions are voluntary and used strictly for
            improving your experience. You may deny or revoke permissions
            anytime via your device settings, but some features may not function
            correctly without them.
          </p>
          <h5
            style={{ fontWeight: "bold", marginTop: "1rem", color: "#17a2b8" }}
          >
            📋 Information Collection and Use
          </h5>
          <p className="contents">
            We may request personal details such as your name, phone number, and
            address to help us provide better service. Your data is safe with
            us.
          </p>

          <h5
            style={{ fontWeight: "bold", marginTop: "1rem", color: "#17a2b8" }}
          >
            📑 Log Data
          </h5>
          <p className="contents">
            Like many sites, we collect log data including IP address, browser
            version, pages visited, and timestamps. This helps us analyze and
            improve our performance.
          </p>

          <h5
            style={{ fontWeight: "bold", marginTop: "1rem", color: "#17a2b8" }}
          >
            🍪 Cookies
          </h5>
          <p className="contents">
            Cookies help personalize your experience. You can choose to accept
            or refuse them. Some features may not work properly if cookies are
            disabled.
          </p>

          <h5
            style={{ fontWeight: "bold", marginTop: "1rem", color: "#17a2b8" }}
          >
            🤝 Service Providers
          </h5>
          <p className="contents">We may engage third-party providers to:</p>
          <ul
            style={{
              paddingLeft: "20px",
              fontSize: "15px",

              color: "#555",
            }}
          >
            <li>Facilitate our Service</li>
            <li>Provide the Service on our behalf</li>
            <li>Perform Service-related tasks</li>
            <li>Analyze usage of the Service</li>
          </ul>
          <p className="contents">
            These providers access your information only to fulfill their tasks
            and are obligated to maintain confidentiality.
          </p>

          <h5
            style={{ fontWeight: "bold", marginTop: "1rem", color: "#17a2b8" }}
          >
            🔐 Security
          </h5>
          <p className="contents">
            We take data security seriously and use industry-standard methods to
            protect your personal information. However, no method is 100%
            secure.
          </p>

          <h5
            style={{ fontWeight: "bold", marginTop: "1rem", color: "#17a2b8" }}
          >
            🔗 Links to Other Sites
          </h5>
          <p className="contents">
            Our site may link to external websites. We are not responsible for
            their content or privacy practices. Please review their policies
            separately.
          </p>

          <h5
            style={{ fontWeight: "bold", marginTop: "1rem", color: "#17a2b8" }}
          >
            👶 Children’s Privacy
          </h5>
          <p className="contents">
            We do not knowingly collect personal data from users under 18. If
            you believe your child has provided us with information, please
            contact us for immediate removal.
          </p>

          <h5
            style={{ fontWeight: "bold", marginTop: "1rem", color: "#17a2b8" }}
          >
            🔄 Changes to This Policy
          </h5>
          <p className="contents">
            This Privacy Policy may be updated occasionally. We advise you to
            review this page regularly. Any changes take effect immediately
            after posting.
          </p>
        </Modal.Body>

        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowTermsPolicy(false)}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>

      {/* ✅ Return Policy Modal */}
      <Modal
        show={showReturnPolicy}
        onHide={() => setShowReturnPolicy(false)}
        centered
        size="lg"
        scrollable
      >
        <Modal.Header closeButton>
          <h4 style={{ color: "#e74c3c", fontWeight: "bold" }}>
            📦 Return & Refund Policy
          </h4>
        </Modal.Header>

        <Modal.Body
          style={{ fontSize: "15px", lineHeight: "1.7", color: "#333" }}
        >
          <div style={{ padding: "10px 15px" }}>
            <p className="p">
              Thank you for shopping at <strong>Yaasaai.com</strong>! Your
              satisfaction is our priority.
            </p>

            <h5 style={{ marginTop: "20px", color: "#2c3e50" }}>🧾 Returns</h5>
            <ul>
              <li>
                🕒 Return within <strong>1 calendar day</strong> from the
                delivery date.
              </li>
              <li>
                📦 Item must be <strong>unused</strong> and in original
                condition.
              </li>
              <li>🎁 Original packaging is required.</li>
              <li>
                🧾 Must have a <strong>receipt or proof of purchase</strong>.
              </li>
            </ul>

            <h5 style={{ marginTop: "20px", color: "#2c3e50" }}>💳 Refunds</h5>
            <ul>
              <li>🔍 We inspect your return upon receipt.</li>
              <li>
                ✅ If approved, refund will be initiated to your original
                payment method.
              </li>
              <li>⏳ Time to reflect depends on your bank's policy.</li>
            </ul>

            <h5 style={{ marginTop: "20px", color: "#2c3e50" }}>🚚 Shipping</h5>
            <ul>
              <li>
                📦 Return shipping cost is the{" "}
                <strong>customer’s responsibility</strong>.
              </li>
              <li>
                💸 Shipping charges are <strong>non-refundable</strong>.
              </li>
              <li>
                ➖ Refund will be adjusted after deducting return shipping
                costs.
              </li>
            </ul>

            <h5 style={{ marginTop: "20px", color: "#2c3e50" }}>
              ❌ Non-returnable Items
            </h5>

            <ul>
              <li>
                ⚠️ Certain perishable or special items may not be eligible for
                return or refund.
              </li>
            </ul>

            <h5 style={{ marginTop: "20px", color: "#2c3e50" }}>
              📞 Contact Us
            </h5>
            <p className="p">
              <strong>Email:</strong>{" "}
              <a href="mailto:yaasaaitonk.com">yaasaaitonk@gmail.com</a>
            </p>
            <p className="p">
              <strong>Phone:</strong>{" "}
              <a href="tel:+917014496283">+91 7014496283</a>
            </p>
            <p className="p">
              <strong>Address:</strong> Kamdhenu Circle, Near FirstCry Mart,
              Captain Colony Chawani Tonk, Rajasthan 304001
            </p>

            <hr style={{ margin: "10px 0", borderTop: "2px solid #ccc" }} />

            <h4 style={{ color: "#27ae60", fontWeight: "bold" }}>
              📋 रिटर्न और रिफंड नीति
            </h4>
            <p className="p">
              <strong>ध्यान दें:</strong> बेचे गए उत्पाद वापस या बदले नहीं
              जाएंगे। केवल क्षतिग्रस्त या एक्सपायर्ड उत्पादों को उचित जांच के
              बाद बदला जाएगा।
            </p>

            <h5 style={{ marginTop: "20px", color: "#34495e" }}>📦 वापसी</h5>
            <ul>
              <li>
                📅 प्राप्ति के <strong>1 दिन</strong> के भीतर प्रोडक्ट वापस
                करें।
              </li>
              <li>🚫 बिना उपयोग के और समान स्थिति में हो।</li>
              <li>
                📦 <strong>मूल पैकेजिंग</strong> में होना चाहिए।
              </li>
              <li>🧾 रसीद या खरीद प्रमाण आवश्यक है।</li>
            </ul>

            <h5 style={{ marginTop: "20px", color: "#34495e" }}>💳 रिफंड</h5>
            <ul>
              <li>🔍 निरीक्षण के बाद रिफंड की स्थिति बताई जाएगी।</li>
              <li>
                ✅ स्वीकृति पर <strong>मूल भुगतान</strong> विधि पर रिफंड होगा।
              </li>
              <li>⏳ समय बैंक की नीति पर निर्भर करता है।</li>
            </ul>

            <h5 style={{ marginTop: "20px", color: "#34495e" }}>🚚 शिपिंग</h5>
            <ul>
              <li>💰 रिटर्न शिपिंग का खर्च ग्राहक को वहन करना होगा।</li>
              <li>🚫 शिपिंग शुल्क वापस नहीं किया जाएगा।</li>
              <li>📉 रिफंड में से यह शुल्क घटाया जाएगा।</li>
            </ul>

            <h5 style={{ marginTop: "20px", color: "#34495e" }}>
              ❌ गैर-वापसी योग्य वस्तुएं
            </h5>
            <p>⚠️ कुछ आइटम वापस नहीं किए जा सकते हैं।</p>

            <h5 style={{ marginTop: "20px", color: "#34495e" }}>
              📞 हमसे संपर्क करें
            </h5>
            <p className="p">
              <strong>ईमेल:</strong>{" "}
              <a href="mailto:yaasaaitonk@gmail.com">yaasaaitonk@gmail.com</a>
            </p>
            <p className="p">
              <strong>फोन:</strong>{" "}
              <a href="tel:+917014496283">+91 7014496283</a>
            </p>
            <p className="p">
              <strong>पता:</strong> कमधेनु चौराहा, फर्स्ट क्राई मार्ट के पास,
              कैप्टन कॉलोनी छावनी टोंक, राजस्थान 304001
            </p>
          </div>
        </Modal.Body>
        {/*
        <Modal.Footer>
          <Button
            variant="secondary"
            onClick={() => setShowReturnPolicy(false)}
          >
            Close
          </Button>
        </Modal.Footer>
        */}
      </Modal>
    </>
  );
};

export default Footer;
